import { FC } from "react";
import Help from "./help";
import About from "./about";
import Others from "./others";
import { useTheme } from "styled-components";
import PricesCalcolators from "componentLayout/Footer/FooterOne/FooterOneDesktop/PricesCalcolators";
import { isShobiddak } from "helpers/osHelpers";
import Image from "../../../../componentReusable/Image";

const FooterOneDesktop: FC = () => {
  const { translations, country } = useTheme();

  return (
    <section id="footerOneDesktop" className="grayBg pt-16 pb-16">
      <div className="width-1200 m-auto flex flex-1 flexSpaceBetween">
        <div className="font-13 darkGrayColor mb-8">
          {isShobiddak() && (
            <>
              <Image
                src="/images/shobiddakLogo/shobiddakLogoDesktop.svg"
                width="106"
                height="42"
                alt={"OpenSooq - السوق المفتوح"}
                className="width-auto block"
              />
              <p className="mt-16 mb-16">
                {translations.footer.copyrights1}
                <br />
                {translations.footer.copyrights2_shobiddak}
                <span dir="ltr" className="ltr">
                  ©{new Date().getFullYear()}
                </span>
              </p>
            </>
          )}
          {(!(country == "ps") || isShobiddak()) && (
            <Image
              src="/images/openSooqLogo/openSooqLogoDesktop.svg"
              width="101"
              height="36"
              alt={"OpenSooq - السوق المفتوح"}
              className="width-auto"
            />
          )}

          {country === "ps" && !isShobiddak() && (
            <>
              <Image
                src="/images/openSooqLogo/openSooqLogoDesktop.svg"
                width="101"
                height="36"
                alt={"OpenSooq - السوق المفتوح"}
                className="width-auto"
              />
              <p className="mt-16 mb-16">
                {translations.footer.copyrights1}
                <br />
                {translations.footer.copyrights2_opensooq}
                <span dir="ltr" className="ltr">
                  ©{new Date().getFullYear()}
                </span>
              </p>
              <Image
                src="/images/shobiddakLogo/shobiddakLogoDesktop.svg"
                width="106"
                height="42"
                alt={"OpenSooq - السوق المفتوح"}
                className="width-auto block"
              />
            </>
          )}
          {!(country == "ps") && !isShobiddak() && (
            <p>
              {translations.footer.copyrights1}
              <br />
              {translations.footer.copyrights2_opensooq}
              <span dir="ltr" className="ltr">
                ©{new Date().getFullYear()}
              </span>
            </p>
          )}
        </div>
        <About />
        <Help />
        <PricesCalcolators />
        <Others />
      </div>
    </section>
  );
};

export default FooterOneDesktop;
